function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7929 16.2071C17.1834 16.5976 17.8166 16.5976 18.2071 16.2071L21.2071 13.2071C21.303 13.1112 21.3753 13.0007 21.4241 12.8828C21.4726 12.7657 21.4996 12.6375 21.5 12.503L21.5 12.5L21.5 12.497C21.4992 12.2421 21.4016 11.9874 21.2071 11.7929L18.2071 8.79289C17.8166 8.40237 17.1834 8.40237 16.7929 8.79289C16.4024 9.18342 16.4024 9.81658 16.7929 10.2071L18.0858 11.5L9.49999 11.5C8.94771 11.5 8.49999 11.9477 8.49999 12.5C8.49999 13.0523 8.94771 13.5 9.49999 13.5L18.0858 13.5L16.7929 14.7929C16.4024 15.1834 16.4024 15.8166 16.7929 16.2071Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 20.5C20.5 21.6046 19.6046 22.5 18.5 22.5L4.49999 22.5C3.39542 22.5 2.49999 21.6046 2.49999 20.5L2.49999 4.5C2.49999 3.39543 3.39542 2.5 4.49999 2.5L18.5 2.5C19.6046 2.5 20.5 3.39543 20.5 4.5V6.35C20.5 6.90229 20.0523 7.35 19.5 7.35C18.9477 7.35 18.5 6.90229 18.5 6.35V4.5L4.49999 4.5L4.49999 20.5L18.5 20.5V18.65C18.5 18.0977 18.9477 17.65 19.5 17.65C20.0523 17.65 20.5 18.0977 20.5 18.65V20.5Z"
});

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#908E8E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7de2c543.svg";
export { ForwardRef as ReactComponent };